import api from '../connectors/Api'

const API = api()

export default {
  namespaced: true,
  state: {
    items: []
  },
  mutations: {
    setItems (state, list) {
      state.items = list
    }
  },
  getters: {
    getName: (state) => (id) => {
      const item = state.items.find(it => it.id === id)
      return item ? item.name : ''
    }
  },
  actions: {
    get ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.getChannelsTypesList(token)
            .then((res) => {
              commit('setItems', res.body)
              resolve(state.items)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    }
  }
}
